import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  MenuItem,
  Paper,
  List,
  ListItem,
  Tooltip,
  Divider,
  Stack,
  CardContent,
  Chip,
  ChipProps,
  IconButton,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useState } from "react";
import { CircularProgress, Grid, Box, Typography } from "@mui/material";
import {
  useChangeStatusOrderListSentToManagerMutation,
  useGetOrderListItemByStoreQuery,
  useGetOrderListByIdQuery,
  useGetUserInfoOnyQuery,
  useOrderListReceiptUpdateMutation,
  useGetRestaurantQuery,
  useGetOrderListHistoryRecordByIdQuery,
  useGetStoreQuery,
  useGetStoreItemOrderListQuery,
  useGetOrderListReceiptQuery,
} from "../../../Api/attoDeskApi";
import {
  IOrderItemViewList,
  IOrderList,
  IOrderListHistoryRecord,
  IRestaurant,
  IOrderListRecordItem,
  IUserAdmin,
  IStore,
  IStoreRefItem,
} from "../../../Api/Interface/api.interface";
import { useParams } from "react-router-dom";
import {
  OrderListStatus,
  SizeOfLevelType,
  fixedPriceConfiem,
} from "../../../Core/Enum/enum";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import dayjs, { Dayjs } from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { useNavigate } from "react-router-dom";
import { useNotifier } from "../../../Core/Notifier";
import StatusPopup from "../../../Components/Delete/StatusPopup";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import ChecklistRtlRoundedIcon from "@mui/icons-material/ChecklistRtlRounded";
import { FaEdit, FaTrash, FaExchangeAlt } from "react-icons/fa";
import { GrStatusGood } from "react-icons/gr";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { IoPricetagsOutline } from "react-icons/io5";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { uploadImage } from "../../../Components/UploadFile/upload";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    case SizeOfLevelType.lb:
      return "lb";
    default:
      return "";
  }
};

const convertStatus = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Order List Created";
    case "SentToManager":
      return "Sent To Manager";
    case "ManagerApproved":
      return "Approved";
    case "UpdatedPrice":
      return "Updated Price";
    case "UpdatedStoreOnly":
      return "Updated Store";
    // case "ManagerConfirmed":
    //   return "Confirmed";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    case "ReceiptUpdated":
      return "Receipt Updated";
    default:
      return "";
  }
};

const statusColor: Record<string, ChipProps["color"]> = {
  Created: "success",
  Modified: "warning",
  Deleted: "error",
};

const statusIcon = {
  Created: <BiSolidMessageSquareAdd color="green" size={17} />,
  Modified: <FaEdit color="orange" />,
  Deleted: <FaTrash color="red" />,
  ChangedBranch: <FaExchangeAlt color="orange" />,
  ChangedStatus: <GrStatusGood color="blue" />,
  storeChanged: <BiSolidMessageSquareAdd size={17} color="green" />,
  priceChanged: <IoPricetagsOutline size={17} color="red" />,
};

const statusMessage: Record<string, string> = {
  ChangedBranch: "Branch changed",
  ChangedStatus: "Status updated",
};

const Index = () => {
  const classes = useStyles();
  const { showErrorMessage, showMessage } = useNotifier();
  const { id: orderListHistoryId, storeId: getStoreIdByItem } = useParams<{
    id: string;
    storeId: string;
  }>();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const navigate = useNavigate();
  const [coursingToStatus, setCoursingToStatus] = useState<string | undefined>(
    ""
  );
  const [open, setOpen] = useState(false);
  const [openOrderListDate, setOpenOrderListDate] = useState(false);
  const [orderList, setOrderList] = useState<IOrderListRecordItem[]>([]);
  const [selectedImage, setSelectedImage] = useState<File | undefined>(
    undefined
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [receiptImg, setReceiptImg] = useState<string | undefined>();

  const {
    data: OrderListDate,
    isLoading: OrderListDateIsLoading,
    isError: OrderListDateIsError,
  } = useGetOrderListByIdQuery({
    searchText: "",
    id: String(orderListHistoryId),
  });

  const {
    data: orderListData,
    isLoading: orderListIsLoading,
    isError: orderListIsError,
  } = useGetOrderListItemByStoreQuery({
    orderId: String(orderListHistoryId),
    storeId: String(getStoreIdByItem),
  });

  const {
    data: receiptData,
    isLoading: receiptIsLoading,
    isError: receiptIsError,
  } = useGetOrderListReceiptQuery({
    orderId: String(orderListHistoryId),
    storeId: String(getStoreIdByItem),
  });

  const {
    data: orderListRecordData,
    isLoading: orderListRecordIsLoading,
    isError: orderListRecordIsError,
    refetch: orderListRecordRefetch,
  } = useGetOrderListHistoryRecordByIdQuery({
    perentTableId: String(orderListHistoryId),
    searchText: "",
  });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const [newStatus, { isLoading }] = useOrderListReceiptUpdateMutation();

  const { data: restaurantData, isLoading: restauramtIsLoading } =
    useGetRestaurantQuery({
      searchText: "",
      id: "",
    });

  const { data: storeData, isLoading: storeIsLoading } = useGetStoreQuery({
    searchText: "",
    id: "",
  });

  const { data: storeRefData, isLoading: storeRefIsLoading } =
    useGetStoreItemOrderListQuery({
      searchText: "",
    });

  const groupedOrderList = useMemo(() => {
    return orderListData?.data ?? {};
  }, [orderListData?.data]);

  const orderListDate = useMemo(() => {
    return OrderListDate?.data as IOrderList[];
  }, [OrderListDate?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const restaurantList = useMemo(() => {
    return restaurantData?.data as IRestaurant[];
  }, [restaurantData?.data]);

  const getAllStoreList = useMemo(() => {
    return storeData?.data as IStore[];
  }, [storeData?.data]);

  const getAllStoreRefList = useMemo(() => {
    return storeRefData?.data as IStoreRefItem[];
  }, [storeRefData?.data]);

  const orderListHisrotyRecord = useMemo(() => {
    return orderListData?.data as IOrderListRecordItem[];
  }, [orderListData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const storeRefMap = useMemo(() => {
    const map = new Map();
    getAllStoreRefList?.forEach((category) => {
      map.set(category.id, `${category.referenceNo}`);
    });
    return map;
  }, [getAllStoreRefList]);

  const userMap2 = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const restaurantMap = useMemo(() => {
    const map = new Map();
    restaurantList?.forEach((category) => {
      map.set(category.id, category.restaurantsName);
    });
    return map;
  }, [restaurantList]);

  const getStoreMap = useMemo(() => {
    const map = new Map();
    getAllStoreList?.forEach((category) => {
      map.set(category.id, category.storeName);
    });
    return map;
  }, [getAllStoreList]);

  const handlePriceChange = (id: number, newPrice: string) => {
    setOrderList((prevList) =>
      prevList.map((item) => {
        if (item.id === id) {
          const unitPrice = parseFloat(newPrice) || 0;
          const totalPrice = unitPrice * item.productTotalUnit;
          return {
            ...item,
            productUnitPrice: unitPrice, // number
            productTotalPrice: totalPrice, // number
          };
        }
        return item;
      })
    );
  };

  // Calculate overall total price
  const totalPrice = orderList.reduce((acc, item) => {
    return acc + (parseFloat(String(item.productTotalPrice)) || 0);
  }, 0);

  const ReDateId =
    orderListDate?.length > 0 ? orderListDate[0].orderListId : null;
  const createBy =
    orderListDate?.length > 0 ? orderListDate[0].created_by : null;
  const createAt =
    orderListDate?.length > 0 ? orderListDate[0].created_at : null;
  const orderListStatus =
    orderListDate?.length > 0 ? orderListDate[0].orderListStatus : null;
  const RestaurantsId =
    orderListDate?.length > 0 ? orderListDate[0].restaurantsId : null;

  const updatedBy =
    orderListDate?.length > 0 ? orderListDate[0].updated_by : null;
  const updatedAt =
    orderListDate?.length > 0 ? orderListDate[0].updated_at : null;

  useEffect(() => {
    if (orderListHisrotyRecord) {
      setOrderList(orderListHisrotyRecord);
    }
  }, [orderListHisrotyRecord]);

  useEffect(() => {
    if (receiptData?.data?.receiptImg) {
      setReceiptImg(receiptData.data.receiptImg); // Define this with useState
    }
  }, [receiptData]);

  const formik = useFormik({
    initialValues: {
      orderListId: "",
      orderList: [],
      receiptImg: receiptData?.data?.receiptImg || "",
      receiptId: receiptData?.data?.id || "",
      storeId: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const formData = new FormData();
        let teamImg: string | undefined;

        let receiptImg: string | undefined =
          receiptData?.data?.receiptImg || teamImg;

        if (selectedImage) {
          setIsImageUploading(true);
          formData.append("receiptImg", selectedImage);
          receiptImg = (await uploadImage(selectedImage)) || "";
          setIsImageUploading(false);
        }

        const temData = {
          orderListId: String(orderListHistoryId),
          storeId: String(getStoreIdByItem),
          orderList: orderList,
          receiptImg,
          receiptId: receiptData?.data?.id || "",
        };

        const addCompanyResponse = await newStatus(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          navigate(`/order/list/set/price/list/${orderListHistoryId}`);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const resizeImage = (
    file: File,
    maxWidth: number,
    maxHeight: number
  ): Promise<File> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target?.result as string;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let width = img.width;
          let height = img.height;

          // Calculate the new dimensions while maintaining aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            if (blob) {
              const resizedFile = new File([blob], file.name, {
                type: file.type,
              });
              resolve(resizedFile);
            } else {
              reject(new Error("Canvas is empty"));
            }
          }, file.type);
        };

        img.onerror = (error) => reject(error);
      };
    });
  };

  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      const maxSize = 2048 * 1024;

      if (!validTypes.includes(file.type)) {
        showErrorMessage("The file must be an image (jpeg, png, jpg, gif).");
        setSelectedImage(undefined);
      } else if (file.size > maxSize) {
        showErrorMessage("The file must be smaller than 2 MB.");
        setSelectedImage(undefined);
      } else {
        try {
          const resizedImage = await resizeImage(file, 500, 500);
          setSelectedImage(resizedImage);
        } catch (error) {
          showErrorMessage("Failed to resize the image.");
          setSelectedImage(undefined);
        }
      }
    } else {
      setSelectedImage(undefined);
    }
  };

  if (
    orderListIsLoading ||
    OrderListDateIsLoading ||
    restauramtIsLoading ||
    storeIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.orderListLeftCardView}>
              <Box
                sx={{
                  height: "90vh",
                  overflow: "auto",
                  padding: "2px",
                  "&::-webkit-scrollbar": {
                    width: "4px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#eeeeee",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#eeeeee",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#eeeeee",
                  },
                }}
              >
                <Grid
                  container
                  spacing={2}
                  my={2}
                  px={1}
                  sx={{ padding: 2 }}
                  className={classes.orderListLeftHeader}
                >
                  <Grid item lg={12} md={12} sm={12} xs={12} mb={2}>
                    <Typography
                      variant="subtitle1"
                      textAlign={"right"}
                      className={classes.OLCardTitle256}
                    >
                      {ReDateId}
                    </Typography>
                    <Typography
                      textAlign={"right"}
                      className={classes.OLLeftHeading}
                    >
                      {convertStatus(orderListStatus || "")}
                    </Typography>
                    <Typography
                      textAlign={"right"}
                      className={classes.OLLeftHeading}
                    >
                      {/* {"Branch : "} */}
                      {restaurantMap.get(RestaurantsId) || ""}
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Card
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: 3,
                        boxShadow: "none",
                        border: `1px solid #d8dfe7`,
                        transition: "0.3s ease-in-out",
                        "&:hover": {
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          border: "0.5px solid #ffffff",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                        },
                      }}
                    >
                      <CardContent
                        sx={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          fontWeight="bold"
                          gutterBottom
                          className={classes.orderLsitHeadingTypoView}
                          style={{
                            fontWeight: "bold",
                            color: "#007bff",
                          }}
                        >
                          Upload Receipt
                        </Typography>
                        <Box className={classes.imgBox2}>
                          {selectedImage ? (
                            <img
                              src={URL.createObjectURL(selectedImage)}
                              alt="Uploaded"
                              className={classes.SelectImageBox}
                            />
                          ) : receiptImg ? (
                            <img
                              src={receiptImg}
                              alt="Existing receipt"
                              className={classes.SelectImageBox}
                            />
                          ) : null}

                          <div>
                            <input
                              accept="image/*"
                              style={{ display: "none" }}
                              id="icon-button-file-1"
                              type="file"
                              onChange={handleImageChange}
                            />
                            <div
                              style={{
                                textAlign: "center",
                              }}
                            >
                              <label htmlFor="icon-button-file-1">
                                <IconButton
                                  color="primary"
                                  aria-label="upload picture"
                                  component="span"
                                >
                                  <CloudUploadIcon sx={{ fontSize: 45 }} />
                                </IconButton>
                              </label>
                            </div>
                          </div>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  <>
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={2}>
                      <Card
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: 3,
                          boxShadow: "none",
                          border: `1px solid #d8dfe7`,
                          transition: "0.3s ease-in-out",
                          "&:hover": {
                            backgroundColor: "#ffffff",
                            borderRadius: "10px",
                            border: "0.5px solid #ffffff",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                          },
                        }}
                      >
                        <CardContent
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Typography
                            fontWeight="bold"
                            gutterBottom
                            className={classes.orderLsitHeadingTypoView}
                            style={{
                              fontWeight: "bold",
                              color: "#007bff",
                            }}
                          >
                            {getStoreMap.get(Number(getStoreIdByItem))}
                          </Typography>
                          <List sx={{ flexGrow: 1 }}>
                            {orderListIsLoading ? (
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  height="10vh"
                                >
                                  <CircularProgress />
                                </Box>
                              </Grid>
                            ) : orderListIsError ? (
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography
                                  textAlign={"center"}
                                  className={classes.leftORTypo}
                                >
                                  Something went wrong
                                </Typography>
                              </Grid>
                            ) : Object.keys(groupedOrderList).length === 0 ? (
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography
                                  textAlign={"center"}
                                  className={classes.leftORTypo}
                                >
                                  No data available
                                </Typography>
                              </Grid>
                            ) : (
                              orderList.map((row: IOrderListRecordItem) => (
                                <React.Fragment key={row.id}>
                                  <ListItem
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      px: 2,
                                      py: 1,
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontWeight: "bold",
                                        color: "#1a202c",
                                        flex: 1,
                                        textAlign: "left",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        window.open(
                                          `/variant/view/${row.productId}`,
                                          "_blank"
                                        )
                                      }
                                    >
                                      {row.variantName}{" "}
                                      {storeRefMap.get(
                                        row.storePerentTableId
                                      ) !== "null" && (
                                        <span style={{ color: "#718096" }}>
                                          (Ref:{" "}
                                          {storeRefMap.get(
                                            row.storePerentTableId
                                          )}
                                          )
                                        </span>
                                      )}
                                    </Typography>

                                    {/* Editable price input + units */}
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "6px",
                                        flex: 2,
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <input
                                        type="number"
                                        step="0.01"
                                        value={row.productUnitPrice ?? ""}
                                        onChange={(e) =>
                                          handlePriceChange(
                                            row.id,
                                            e.target.value
                                          )
                                        }
                                        style={{
                                          width: 120,
                                          padding: "6px 10px",
                                          borderRadius: 6,
                                          border: "1px solid #ccc",
                                          fontWeight: 500,
                                          fontSize: "0.95rem",
                                          textAlign: "center",
                                          background: "#fefefe",
                                          boxShadow:
                                            "inset 0 1px 2px rgba(0,0,0,0.05)",
                                        }}
                                      />
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          fontSize: "0.9rem",
                                          color: "#333",
                                        }}
                                      >
                                        {" × " +
                                          row.productTotalUnit +
                                          " " +
                                          convertUnit(row.variantUnit)}
                                      </Typography>
                                    </div>

                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#555",
                                        flex: 1,
                                        textAlign: "right",
                                      }}
                                    >
                                      {`$${Number(
                                        row.productTotalPrice
                                      ).toFixed(2)}`}
                                    </Typography>
                                  </ListItem>

                                  <Divider />
                                </React.Fragment>
                              ))
                            )}
                            <ListItem
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                px: 2,
                                py: 1,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  backgroundColor: "#f0f4f8",
                                  padding: "8px",
                                  borderRadius: "8px",
                                  marginTop: "8px",
                                  border: "1px solid #ccc",
                                  minWidth: 300,
                                }}
                              >
                                <Typography
                                  variant="body1"
                                  style={{
                                    fontWeight: "bold",
                                    color: "#333",
                                  }}
                                >
                                  {"Total Price : "}
                                </Typography>

                                <Typography
                                  variant="body1"
                                  style={{
                                    fontWeight: "bold",
                                    color: "#007bff",
                                  }}
                                >
                                  {`$${totalPrice.toFixed(2)}`}
                                </Typography>
                              </div>
                            </ListItem>
                          </List>
                        </CardContent>
                      </Card>
                    </Grid>
                  </>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={3}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={() => {
                            navigate(
                              `/order/list/set/price/list/${orderListHistoryId}`
                            );
                          }}
                        >
                          Cancel
                        </Button>
                        <Box m={0.5}></Box>

                        <Button
                          variant="contained"
                          startIcon={
                            isLoading ? (
                              <CircularProgress
                                size={18}
                                className={classes.isLoading}
                              />
                            ) : (
                              <CheckCircleOutlineIcon />
                            )
                          }
                          className={classes.addButton}
                          onClick={() => formik.handleSubmit()}
                          //   disabled={!formValid}
                        >
                          Update
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default Index;
